import {Component, ChangeDetectionStrategy, OnInit, inject} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { TranslateModule } from '@ngx-translate/core';
import { ElectronicFieldMapSummaryComponent } from '@components/electronic-field-map-summary/electronic-field-map-summary.component';
import { AuthService } from '@services/auth.service';
import { ISummaryItem } from '@root/src/app/components/ui/summary-items-list/summary-items-list';
import { SummaryParent } from '@root/src/app/wrappers/summary-parent';
import { ThemeModule } from '@root/src/app/themes/theme-module';

@Component({
  selector: 'app-electronic-field-map-page',
  standalone: true,
  imports: [CommonModule, CardModule, TranslateModule, ElectronicFieldMapSummaryComponent, ThemeModule],
  templateUrl: './administration-summary.html',
  styleUrl: './administration-summary.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ElectronicFieldMapPageComponent extends SummaryParent implements OnInit {

  authService = inject(AuthService);

  items: ISummaryItem[] = [
    {
      icon: 'assets/icons/main/light/licon-ead-icon.svg',
      iconBack: 'assets/icons/main/light/user-icon-line-chart-fill.svg',
      title: 'Logging',
      url: '/admin/logging',
      cardStyle: { background: '#B48EFFCC' }
    },
    {
      icon: 'assets/icons/main/light/task-ead-icon.svg',
      iconBack: 'assets/icons/main/light/task-icon-line-chart-fill.svg',
      title: 'Task Scheduler',
      url: '/admin/task-scheduler',
      cardStyle: { background: '#6DDE89' }
    },
    {
      icon: 'assets/icons/main/light/system-lead-icon.svg',
      iconBack: 'assets/icons/main/light/system-icon-line-chart-fill.svg',
      title: 'System Status',
      url: '/admin/system-status',
      cardStyle: { background: '#0088FFB2' }
    },
    {
      icon: 'assets/icons/main/light/data-managment.svg',
      iconBack: 'assets/icons/main/light/data-management-back.svg',
      title: 'Data Management',
      url: '/admin/data-management',
      cardStyle: { background: '#c8cad1' }
    },
    {
      icon: 'assets/icons/main/light/user-help.svg',
      iconBack: 'assets/icons/main/light/user-help-back.svg',
      title: 'User Support',
      url: '/admin/appeals',
      cardStyle: { background: '#b8dde1' }
    },
    {
      icon: 'assets/icons/main/light/manage-file.svg',
      iconBack: 'assets/icons/main/light/manage-file-back.svg',
      title: 'File Storage Management',
      url: '/admin/file-storage',
      cardStyle: { background: '#c8cad1' }
    },
    {
      icon: 'assets/icons/main/light/manage-file.svg',
      iconBack: 'assets/icons/main/light/manage-file-back.svg',
      title: 'System Documentation',
      url: '/admin/system-documentation',
      cardStyle: { background: '#E8D5C4' }
    },
    {
      icon: 'assets/icons/main/light/manage-file.svg',
      iconBack: 'assets/icons/main/light/manage-file-back.svg',
      title: 'System Documentation Blocks',
      url: '/admin/system-documentation-blocks',
      cardStyle: { background: '#D4C5B8' }
    },
  ];

  ngOnInit(): void {
    if (this.authService.isAdmin()) {
      this.items.unshift({
        icon: 'assets/icons/main/light/icon-lead-icon.svg',
        iconBack: 'assets/icons/main/light/icon-line-chart-fill.svg',
        title: 'User Management',
        url: '/admin/user-management',
        cardStyle: { background: '#ffd859' }
      });
    }
  }
}